<template>
    <div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="ml-2 d-flex align-items-center"
        variant="primary"
        @click="openSideBar"
      >
        <feather-icon class="mr-1" icon="FlagIcon" size="21" />
        {{ $tc('Global.New', 3) }} {{ $t('Management.Countries.Country') }}
      </b-button>
      <Form
        ref="form"
        :country="country"
        :can="$can($acl.action.Create, $acl.subjects.Countries)"
        :header="$tc('Global.New', 2) + ' ' + $t('Management.Countries.Country')"
        @submit="submit"
        @reset="reset"
      />
    </div>
  </template>
  
  <script>
  import { BButton } from 'bootstrap-vue'
  import Form from './form.vue'
  
  export default {
    components: {
      Form,
      BButton,
    },
    props: {
      countries: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      country: {
        name: null,
        short: null,
        isThirdCountry: false
      },
    }),
  
    methods: {
      reset() {
        this.country = {
          name: null,
          short: null,
          isThirdCountry: false
        }
      },
      openSideBar() {
        this.$refs.form.sidebarVisible = true
      },
      async submit() {
        try {
          const { data } = await this.$axios.post('countries', this.country)
  
          this.$alert.create(`${data.name}`)
          this.$emit('add', data)
  
          const { form } = this.$refs
          form.dirty = false
          form.sidebarVisible = false
        } catch {
          this.$alert.error()
        }
      },
    },
  }
  </script>
  